import React, {Component} from 'react';
import collaborate from '../gifs/collaborate-1.gif';
import fork from '../fork.png';
import pr from '../pr.png';

class Collaborate extends Component {


    render() {
        return(
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-5" style={{justifyContent: "center", alignItems: "center", padding:"25px"}}>
                        <img src={collaborate} alt="Oops!" height="100%" width="100%" justifyContent="center" backgroundSize="cover"/>
                    </div>
                    <div className="col-12 col-md-6 my-auto" style={{justifyContent: "space-around",padding:"25px", alignItems: "center"}}>
                        <h2 style={{fontFamily:'Menlo'}}>Collaborate</h2>
                        <hr style={{height:"1.2px", width:"16%",textAlign:"left",marginLeft:"0",backgroundColor:"gray"}}/>
                        <p style={{fontFamily:"Montserrat", fontSize:"22px"}}>&emsp;&emsp;Become a Open-source Contributor by contributing to Open-source projects.</p>
                        <cite style={{fontFamily:"Montserrat", color:"gray"}}>Contribute &amp; Collaborate.</cite>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{justifyContent: "space-around",padding:"28px", alignItems: "center"}}>
                            <h2 style={{fontFamily:'Menlo'}}>What can I Contribute?</h2>
                            <hr style={{height:"1.2px", width:"16%",textAlign:"left",marginLeft:"0",backgroundColor:"gray"}}/>
                            <p style={{fontFamily:"Montserrat", fontSize:"20px", color:"#2A2A2A"}}>&emsp;&emsp;If you have this question then, you are one step closer to becoming a Open-source Contributor.<br/>The following are considered as Open-source contribution:
                                <ul>
                                    <li>Helping in maintaining documentation</li>
                                    <li>Reporting/Fixing a bug</li>
                                    <li>Requesting/Adding a new feature</li>
                                    <li>Improving the code</li>
                                </ul>
                            </p>
                            
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{justifyContent: "space-around",padding:"28px", alignItems: "center"}}>
                            <h2 style={{fontFamily:'Menlo'}}>How can I Contribute?</h2>
                            <hr style={{height:"1.2px", width:"16%",textAlign:"left",marginLeft:"0",backgroundColor:"gray"}}/>
                            <p style={{fontFamily:"Montserrat", fontSize:"20px", color:"#2A2A2A"}}>&emsp;&emsp;If you have reached this section and are interested in open-source contribution then do the following to get started:
                                <ol>
                                    <li>
                                        Go to the project repository that you want to contribute to.
                                    </li>
                                    <li>
                                        Click on the fork <span> <img src={fork} alt="" height="18px"/> </span> icon to fork the repository.
                                    </li>
                                    <li>
                                        Clone the repository in your computer.<br/> 
                                        <div className="container" style={{background: "#2A2A2A", borderRadius:"0.35rem"}}>
                                            <pre style={{padding: "1rem"}}>
                                                <code style={{fontFamily:"Menlo",fontSize:"14px", color:"white"}}>
                                                    E:\syedyshiraz\example&gt;git clone portfolio<br/>
                                                </code>
                                            </pre>
                                        </div>
                                    </li>
                                    <li>
                                        Navigate to the file in your terminal/command-prompt.<br/>
                                        <div className="container" style={{background: "#2A2A2A", borderRadius:"0.35rem"}}>
                                            <pre style={{padding: "1rem"}}>
                                                <code style={{fontFamily:"Menlo",fontSize:"14px", color:"white"}}>
                                                    E:\syedyshiraz\example&gt;cd portfolio<br/>
                                                </code>
                                            </pre>
                                        </div>
                                    </li>
                                    <li>
                                        Run the following command.<br/>
                                        <div className="container" style={{background: "#2A2A2A", borderRadius:"0.35rem"}}>
                                            <pre style={{padding: "1rem"}}>
                                                <code style={{fontFamily:"Menlo",fontSize:"14px", color:"white"}}>
                                                    E:\syedyshiraz\example\portfolio&gt;git checkout -b &lt;branch-name&gt;<br/>
                                                </code>
                                            </pre>
                                        </div>
                                    </li>
                                    <li>
                                        Make changes in the repository and commit changes.<br/>
                                        <div className="container" style={{background: "#2A2A2A", borderRadius:"0.35rem"}}>
                                            <pre style={{padding: "1rem"}}>
                                                <code style={{fontFamily:"Menlo",fontSize:"14px", color:"white"}}>
                                                E:\syedyshiraz\example\portfolio&gt;git add .<br/>
                                                E:\syedyshiraz\example\portfolio&gt;git commit -m "&lt;commit message&gt;"<br/>
                                                E:\syedyshiraz\example\portfolio&gt;git push -u origin master
                                                </code>
                                            </pre>
                                        </div>
                                    </li>
                                    <li>
                                        In your forked repository in Github click on pull changes
                                    </li>
                                    <li>
                                        Create a PR (Pull Request) <span> <img src={pr} alt="" height="18px"/> </span>for the repository owner to merge the changes.
                                        
                                    </li>
                                </ol>
                            </p>  
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{justifyContent: "space-around",padding:"28px", alignItems: "center"}}>
                                <h2 style={{fontFamily:'Menlo'}}>Congratulations!</h2>
                                <hr style={{height:"1.2px", width:"16%",textAlign:"left",marginLeft:"0",backgroundColor:"gray"}}/>
                                <p style={{fontFamily:"Montserrat", fontSize:"20px", color:"#2A2A2A"}}>&emsp;&emsp;You have learnt the art of Open-source Contribution.
                                    <br/>Now find a project in the Projects tab and Collaborate.
                                </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Collaborate;